import React from 'react';

const Card = ({ image, title, body, extraClass }) => {
  return (
    <section className={`w-full px-8 py-10 shadow-md rounded-md flex flex-col items-center md:py-0 md:px-0 md:flex-row md:items-start md:shadow-none ${extraClass}`}>
      <img src={image} alt="" className="2xl:h-24" />
      <div className="pt-4 md:pt-0 md:ml-2 2xl:ml-8">
        <p className="uppercase text-slate-700 font-medium tracking-widest text-center md:pt-0 md:text-left 2xl:text-2xl">{title}</p>
        <p className="tracking-wider text-slate-700 font-light text-sm text-center md:text-left 2xl:text-xl">{body}</p>
      </div>
    </section >
  );
};

export default Card;
